import { REACT_APP_AMPLITUDE_API_KEY } from './envConfig';

export const API_KEY = REACT_APP_AMPLITUDE_API_KEY;

export const AMPLITUDE_EVENT = {
  COMPANY_SEARCH_EXECUTED: 'Company Search Executed',
  COMPANY_PROJECT_CREATED: 'Company Project Created',
  COMPANY_MOVED_TALENT: 'Company Moved Talent',
};
